"use client"

import { useEffect, useRef, useState } from "react"

type Props = { value: string }

// Анимируем только ведущее число (напр. "2 мин", "0 ₽ штраф", "120+ клиентов"). Остальное — как есть.
const NUMERIC_PREFIX = /^(\d+)([.,]\d+)?/

export function StatValue({ value }: Props) {
  const match = value.match(NUMERIC_PREFIX)
  const target = match ? parseInt(match[1], 10) : null
  const suffix = match ? value.slice(match[0].length) : ""

  const ref = useRef<HTMLSpanElement>(null)
  const [display, setDisplay] = useState<string>(target !== null ? "0" : value)
  const played = useRef(false)

  useEffect(() => {
    if (target === null) return
    const el = ref.current
    if (!el) return

    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (reduced) {
      setDisplay(String(target))
      return
    }

    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (!e.isIntersecting || played.current) continue
          played.current = true
          const start = performance.now()
          const duration = 600
          const from = 0
          const tick = (now: number) => {
            const t = Math.min(1, (now - start) / duration)
            const eased = 1 - Math.pow(1 - t, 3)
            setDisplay(String(Math.round(from + (target - from) * eased)))
            if (t < 1) requestAnimationFrame(tick)
          }
          requestAnimationFrame(tick)
          io.disconnect()
        }
      },
      { threshold: 0.4 },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [target])

  if (target === null) {
    return <span ref={ref}>{value}</span>
  }
  return (
    <span ref={ref}>
      {display}
      {match?.[2] ?? ""}
      {suffix}
    </span>
  )
}
